import React from "react";

export default function FullPageLoader() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-900/40 backdrop-blur-sm z-50">
      <div className="h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      <p className="text-white mt-3 text-sm">Loading...</p>
    </div>
  );
}
